import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import taiyo from "../../Assets/Projects/taiyo.png";
import platterbot from "../../Assets/Projects/platterbot.png";
import giveawaybot from "../../Assets/Projects/giveawaybot.png";
import riskflow from "../../Assets/Projects/riskflow.png";
import yaynuts from "../../Assets/Projects/yaynuts.png";
import sportivo from "../../Assets/Projects/sportivo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={riskflow}
              isBlog={false}
              title="Google Workspace Security Risk Assessment"
              description="Built using Vite, React, Node.js, and Redis to analyze Google Workspace policies, compare them with industry best practices, and return a comprehensive score."
              ghLink=""
              demoLink="https://riskflow-sra-frontend.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={platterbot}
              isBlog={false}
              title="Smart AI-Recipe Generator"
              description="Built using Next.js, Tailwind CSS and Generative AI to generate recipes based on the ingredients, dietary restrictions and cuisine provided by the user. Authenticated by Clerk and powered by Google's Gemini AI following a prompt-based approach."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={giveawaybot}
              isBlog={false}
              title="Invite Tracker and Giveaway Discord Bot"
              description="Empowers Discord server owners to track the invites of their members and host giveaways. Built using Discord.js, MongoDB, and Node.js."
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sportivo}
              isBlog={false}
              title="College Sports Club Official Website"
              description="Built using Next.JS, Firebase and Google Apps Script to provide information about the club, its members, and upcoming events. The website also includes proper authentication and authorization for the members, powered by NextAuth.js."
              ghLink=""
              demoLink="https://sportivo.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={yaynuts}
              isBlog={false}
              title="Social Media Integration and Affiliate Reminder Bot"
              description="Fetches the latest posts from Instagram, Tiktok, Youtube and sends them to the Discord server. Also, tracks affiliate posts and sends post reminders to the server. Built using Discord.js, MongoDB, Meta API, Youtube Data API, and node-cron."
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={taiyo}
              isBlog={false}
              title="Covid-19 Charts and Region Wise Data"
              description="Built using React, Chart.js, and Leaflet to display Covid-19 data in the form of charts and maps. The data is fetched from the Covid-19 API, and country wise data is displayed using Leaflet."
              ghLink="https://github.com/spidy7878/taiyo"
              demoLink="https://taiyo-vert.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
